<template>
    <otif-select
        :field="field"
        :label="label"
        :description="description"
        :values="paramSets"
        :value="selectedSet"
        @input="onInput"
        :loading="loading"
        :disabled="loading"
        :validation="validation"
        :invalidMessage="invalidMessage">

    </otif-select>
</template>

<script>

export default {

    data() {
        return {
            loading: true,
            paramSets:[]
        }
    },

    props: ['field', 'label', 'description', 'selectedSet', 'validation', 'invalidMessage', 'parameters'],

    created() {
        this.refresh();
    },

    methods: {
        refresh() {
            this.loading = true;

            this.paramSets = this.parameters.map((oneSet) => {
                    return {
                        label: oneSet.description,
                        value: oneSet.index,
                    }
           
            });
            this.value = Number(this.selectedSet);
            this.loading = false;
        },

        onInput(val) {
            if (val != this.value) {
                this.$emit('reselected', val);
                this.value=val;
            }
        }
    }

};

</script>
